<template>
  <el-dialog
    :title="dialogInfo.title"
    :visible.sync="dialogInfo.show"
    :close-on-click-modal="false"
    width="550px"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="130px"
      size="small"
      class="form"
    >
      <el-form-item label="班级排序码：" prop="order">
        <el-input-number
          v-model="ruleForm.order"
          step-strictly
        ></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click.native="close" size="small">取消</el-button>
      <el-button type="primary" size="small" @click.native="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateOrder } from "@/api/classOffline";
export default {
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          title: "修改班级排序码",
          order: 0,
          uuid: ""
        };
      },
    },
  },
  data() {
    return {
      ruleForm: {
        order: 0,
      },
      rules: {
        order: [{
          required: true,
          message: "请输入排序码",
          trigger: "change"
        }]
      },
    };
  },
  created() {
    this.ruleForm.order = this.dialogInfo.order || 0;
  },
  methods: {
    confirm() {
      updateOrder({ order: this.ruleForm.order, uuid: this.dialogInfo.uuid }).then(
        ({ code, msg }) => {
          if (code !== 0) return;
          this.$message.success(msg);
          this.$emit("closeOrder", true);
        }
      );
    },
    close() {
      this.$emit("closeOrder", false);
    },
  },
};
</script>

<style>
</style>